export default __webpack_public_path__ + "static/media/ava-3.14420750.jpg";